import { render, staticRenderFns } from "./BtnEditarItemContrato.vue?vue&type=template&id=948e8554"
import script from "./BtnEditarItemContrato.vue?vue&type=script&lang=js"
export * from "./BtnEditarItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports